import {
  GetOutputSchemaParams,
  GetOutputSchemasParams,
  TableSchema,
  TableSchemasList,
  WorkflowComponentInput,
  WorkflowComponentMetadata,
  WorkflowComponentOutputType,
  WorkflowComponentParameterMode,
  WorkflowComponentParamType
} from '../../types'
import { WorkflowComponent } from './workflowcomponent'

const DRYRUN = 'dryrun'

export const SINGLE_OUTPUT_NAME = 'result'

export abstract class SingleOutputWorkflowComponent extends WorkflowComponent {
  constructor(
    metadata: WorkflowComponentMetadata,
    inputs: WorkflowComponentInput[]
  ) {
    const outputs = [
      {
        name: SINGLE_OUTPUT_NAME,
        title: 'Result table',
        description: 'Result table',
        type: WorkflowComponentOutputType.Table
      }
    ]
    super(metadata, inputs, outputs)
  }

  getOutputSchema({
    columns,
    params,
    connection
  }: GetOutputSchemaParams): TableSchema {
    return []
  }

  _getOutputSchemas({
    workflow,
    connection,
    params,
    schemas,
    componentName
  }: GetOutputSchemasParams): TableSchemasList {
    if (!this.canProvideOutputSchemas()) {
      return []
    }
    const fqn = this._getDryRunOutputTableFqn(
      workflow,
      params,
      connection,
      componentName,
      SINGLE_OUTPUT_NAME
    )
    const columns = {}
    const keys = this.inputs
      .filter((input) => input.type === WorkflowComponentParamType.InputTable)
      .filter((input) => input.mode !== WorkflowComponentParameterMode.Multiple)
      .map((input) => input.name)
      .concat([DRYRUN])
    for (const key of keys) {
      const tablename = key === DRYRUN ? fqn : (params[key] as string)
      columns[key] =
        tablename == null
          ? []
          : this._getSchemaForTablename(tablename, schemas, connection) || []
    }

    return [
      {
        fqn,
        schema: this.getOutputSchema({
          columns,
          params,
          connection
        })
      }
    ]
  }
}
